import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";
import RouteTracker from "@/components/RouteTracker";

import Home from "@/pages/public/Home";
import Services from "@/pages/public/Services";
import Projects from "@/pages/public/Projects";
import ProjectDetail from "@/pages/public/ProjectDetail";
import FloorPlans from "@/pages/public/FloorPlans";
import FloorPlanDetail from "@/pages/public/FloorPlanDetail";
import About from "@/pages/public/About";
import Contact from "@/pages/public/Contact";
import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";

import AdminOverview from "@/pages/admin/Overview";
import AdminLeads from "@/pages/admin/Leads";
import AdminClients from "@/pages/admin/Clients";
import AdminProjects from "@/pages/admin/Projects";
import AdminFloorPlans from "@/pages/admin/FloorPlans";
import AdminEstimates from "@/pages/admin/Estimates";
import AdminInvoices from "@/pages/admin/Invoices";
import AdminTestimonials from "@/pages/admin/Testimonials";
import AdminDocuments from "@/pages/admin/Documents";

import PortalHome from "@/pages/portal/PortalHome";
import PortalEstimates from "@/pages/portal/PortalEstimates";
import PortalInvoices from "@/pages/portal/PortalInvoices";
import PortalDocuments from "@/pages/portal/PortalDocuments";
import PaymentSuccess from "@/pages/portal/PaymentSuccess";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <RouteTracker />
          <Routes>
            {/* Public */}
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:id" element={<ProjectDetail />} />
            <Route path="/floor-plans" element={<FloorPlans />} />
            <Route path="/floor-plans/:id" element={<FloorPlanDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />

            {/* Auth */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            {/* Admin */}
            <Route path="/admin" element={<ProtectedRoute role="admin"><AdminOverview /></ProtectedRoute>} />
            <Route path="/admin/leads" element={<ProtectedRoute role="admin"><AdminLeads /></ProtectedRoute>} />
            <Route path="/admin/clients" element={<ProtectedRoute role="admin"><AdminClients /></ProtectedRoute>} />
            <Route path="/admin/projects" element={<ProtectedRoute role="admin"><AdminProjects /></ProtectedRoute>} />
            <Route path="/admin/floor-plans" element={<ProtectedRoute role="admin"><AdminFloorPlans /></ProtectedRoute>} />
            <Route path="/admin/estimates" element={<ProtectedRoute role="admin"><AdminEstimates /></ProtectedRoute>} />
            <Route path="/admin/invoices" element={<ProtectedRoute role="admin"><AdminInvoices /></ProtectedRoute>} />
            <Route path="/admin/testimonials" element={<ProtectedRoute role="admin"><AdminTestimonials /></ProtectedRoute>} />
            <Route path="/admin/documents" element={<ProtectedRoute role="admin"><AdminDocuments /></ProtectedRoute>} />

            {/* Client portal */}
            <Route path="/portal" element={<ProtectedRoute><PortalHome /></ProtectedRoute>} />
            <Route path="/portal/estimates" element={<ProtectedRoute><PortalEstimates /></ProtectedRoute>} />
            <Route path="/portal/invoices" element={<ProtectedRoute><PortalInvoices /></ProtectedRoute>} />
            <Route path="/portal/documents" element={<ProtectedRoute><PortalDocuments /></ProtectedRoute>} />
            <Route path="/portal/payment-success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
